var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlightRosterIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 7657"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6538 0.346146C26.1153 0.807674 26.1153 1.55596 25.6538 2.01749L12.6538 15.0175C12.1923 15.479 11.444 15.479 10.9825 15.0175C10.521 14.5559 10.521 13.8077 10.9825 13.3461L23.9825 0.346146C24.444 -0.115382 25.1923 -0.115382 25.6538 0.346146Z",
    fill: "#BCAB79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6538 0.346179C25.9748 0.667205 26.0836 1.14375 25.9336 1.57226L17.6609 25.2086C17.5008 25.666 17.0778 25.9793 16.5936 25.999C16.1094 26.0188 15.6623 25.741 15.4655 25.2982L10.9228 15.0772L0.701841 10.5345C0.259038 10.3377 -0.0187643 9.89056 0.000988335 9.40639C0.020741 8.92222 0.334045 8.49918 0.791409 8.3391L24.4277 0.0663821C24.8562 -0.0835969 25.3328 0.0251529 25.6538 0.346179ZM4.38582 9.58528L12.2982 13.1019C12.5655 13.2207 12.7793 13.4345 12.8981 13.7018L16.4147 21.6142L22.8918 3.10818L4.38582 9.58528Z",
    fill: "#BCAB79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlightRosterIcon);
export default __webpack_public_path__ + "static/media/flight-roster-icon.27bcae42e10c5a0084dcf4f7b1a6649a.svg";
export { ForwardRef as ReactComponent };